<div class="row mt-5 mb-2">
    <div class="col-3"></div>
    <div class="col-6">

        <div class="example-header">
            <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
            </mat-form-field>
        </div>

    </div>

</div>
<div class="row">
    <div class="col-9"></div>
    <div class="col-3">
        <button mat-raised-button color="warn" (click)="supprimer()">Supprimer la selection</button>

    </div>
</div>
<div class="row mt-5" id="cons" >
    <div class="col-1"></div>
    <div class="col-md-10">



        <div class="mb-5 col-xs">
            <div class="example-container mat-elevation-z8">
                <mat-table #table [dataSource]="listResult" matSort>
                    <!-- Position Column -->
                    <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <p> ID</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p> {{element.id}}
                            <p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="civilite">
                        <mat-header-cell *matHeaderCellDef>
                            <p>Numéro de téléphone</p>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p> {{element.numTel}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="delete">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <mat-checkbox  (change)="toggle(element.id)" class="example-margin" ></mat-checkbox>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns1"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns1;"></mat-row>
                </mat-table>
                <mat-paginator [pageSizeOptions]="[10,20,50,100]"></mat-paginator>

            </div>
        </div>
    </div>

</div>


<div class="row">
    <div class="col-1"></div>
    <div class="col-10">

            <div class="main-card mb-3 card" style="height: 94%;">
                <div class="card-body">

                    <form [formGroup]="uploadForm" (ngSubmit)="uploadSubmit()">
                        <mat-card-content>


                            <input formControlName="document" class="foo" type="file" ng2FileSelect
                                [uploader]="uploader" (change)="onFileChange($event)" /><br />

                            <hr>
                            <div class="drop-zone">
                                <div ng2FileDrop [uploader]="uploader" style="min-height: 150px;
                        border: 2px dashed #00B5B8;
                        background: #F5F7FA;" class="drop-zone">
                                    <h2 class="text-center mt-5">Glissez le document Black Liste</h2>
                                </div>
                            </div>

                            <table>
                                <thead>
                                    <tr>
                                        <th width="90%">

                                        </th>
                                        <th width="10%">

                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of uploader.queue;let x=index">
                                        <th width="90%">
                                            document {{x+1}}
                                        </th>
                                        <th class="text-center" width="20%">
                                            <button type="button" class="btn btn-light" (click)="effacer()" (click)="item.remove()">
                                                Annuler
                                             </button>

                                        </th>
                                    </tr>
                                    
                                </tbody>
                            </table>
                            <table class="table" width="100%" *ngIf="dataExel != null">
                                <thead>
                                    <tr>
                                        <th>Numéro du téléphone</th>
                                        
    
                                    </tr>
                                </thead>
                                <tbody *ngFor="let row of dataExel;let i =index">
                                    <tr *ngIf="i &#60; 4">
                                        <td>{{row.num}}</td>
                                       
    
    
                                    </tr>
                                </tbody>
                            </table>
                            <br>
                        </mat-card-content>
                    </form>

                </div>

                <div class=" d-block text-left card-footer">
                    <button class="mb-2 mr-2 btn btn-primary" (click)="uploadSubmit()">Enregistrer</button>
                </div>
                <div class="alert alert-warning" *ngIf="isOk == false">
                    Upload échouée!
                </div>

                <div class="alert alert-success" *ngIf="isOk == true">
                    Votre upload est réussie!
                </div>
            </div>



    </div>
</div>